import styled from '@emotion/styled';
import Responsive from '../../utils/Responsive';

export const StyledCardChildren = styled.div`
	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		margin-bottom: 4px;
		margin-top: 4px;
	}
`;
